// Created by PeakXin on 2025/12/25.
import { getStudentBase, getStudentDetail } from '@/api/student'

const state = {
  studentBase: {}
}

const getters = {
  studentBase: (state) => state.studentBase
}

const mutations = {
  SET_STUDENT_BASE: (state, studentBase) => {
    state.studentBase = studentBase
  }
}

const actions = {
  // 获取学生基础信息
  getStudentBase({ commit, dispatch }) {
    return new Promise(async (resolve, reject) => {
      try {
        // 通过 getInfo() 方法获取最新的 userInfo
        const userInfo = await dispatch('user/getInfo', null, { root: true })

        // 判断 userInfo 的 member 属性值是否有信息
        if (userInfo && userInfo.member) {
          // 有 member 属性值，调用 getStudentBase 方法
          getStudentBase()
            .then((response) => {
              const { data } = response
              if (!data) {
                reject('验证失败，请重新登录')
              }
              // 设置store中的studentBase
              commit('SET_STUDENT_BASE', data)
              resolve(data)
            })
            .catch((error) => {
              reject(error)
            })
        } else {
          // 没有 member 属性值，清空 studentBase 并完成流程，无需报错
          commit('SET_STUDENT_BASE', {})
          console.log('userInfo 没有 member 属性值')
          resolve(null)
        }
      } catch (error) {
        reject(error)
      }
    })
  },
  // 获取学生详细信息
  getStudentDetail({ commit, dispatch }) {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await getStudentDetail()
        resolve(response)
      } catch (error) {
        reject(error)
      }
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
